import { PipelineStepType } from './pipelineBuilder.types'

const REQUIRED_STEP_TYPES: PipelineStepType[] = ['prospects', 'leads']

const NON_REPEATABLE_STEP_TYPES: PipelineStepType[] = [
    'prospects',
    'leads',
    'application',
    'screening',
    'qualification',
    'lease',
    'future_resident',
]

export function isRequiredStepType(type: PipelineStepType): boolean {
    return REQUIRED_STEP_TYPES.includes(type)
}

export function isStepRemovable(type: PipelineStepType): boolean {
    return !isRequiredStepType(type)
}

export function isStepDisableable(type: PipelineStepType): boolean {
    return !isRequiredStepType(type)
}

export function isStepRepeatable(type: PipelineStepType): boolean {
    return !NON_REPEATABLE_STEP_TYPES.includes(type)
}
